(() => {
  const productId = 10126326333687;
  const variants = new Set(['51279806234871','51279806267639','51279806300407','51279806333175']);
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const limitMessage = 'One pack of pee pads is allowed per order. Please keep another product in your cart.';
  async function request(path, options = {}) {
    const response = await fetch(root + path, {credentials:'same-origin', ...options, headers:{Accept:'application/json', ...(options.headers || {})}});
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to update your cart. Please try again.');
    return data;
  }
  function getState(cart) {
    const pads = (cart.items || []).filter(item => Number(item.product_id) === productId).reduce((sum,item) => sum + Number(item.quantity || 0),0);
    const other = (cart.items || []).some(item => Number(item.product_id) !== productId && Number(item.quantity || 0) > 0);
    return {pads, other, invalid:pads > 1 || (pads > 0 && !other)};
  }
  function updateDots(offer) {
    const track = offer.querySelector('[data-addon-carousel]');
    const cards = [...offer.querySelectorAll('[data-addon-card]')].filter(card => !card.hidden);
    const controls = offer.querySelector('[data-addon-controls]');
    if (controls) controls.hidden = cards.length < 2;
    if (cards.length < 2) return;
    const trackLeft = track.getBoundingClientRect().left;
    let activeIndex = 0;
    let nearestDistance = Infinity;
    cards.forEach((card, index) => {
      const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        activeIndex = index;
      }
    });
    offer.querySelectorAll('[data-addon-dot]').forEach(dot => {
      dot.setAttribute('aria-current', String(Number(dot.dataset.addonDot) === activeIndex));
    });
  }
  function startAutoPlay(offer) {
    if (offer.dataset.addonAutoPlay === 'true') return;
    offer.dataset.addonAutoPlay = 'true';
    window.setInterval(() => {
      if (document.hidden || offer.hidden) return;
      const track = offer.querySelector('[data-addon-carousel]');
      const cards = [...offer.querySelectorAll('[data-addon-card]')].filter(card => !card.hidden);
      if (!track || cards.length < 2) return;
      const dots = [...offer.querySelectorAll('[data-addon-dot]')];
      const activeIndex = dots.findIndex(dot => dot.getAttribute('aria-current') === 'true');
      const nextIndex = (activeIndex + 1 + cards.length) % cards.length;
      const card = cards[nextIndex];
      if (!card) return;
      const left = track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollTo({left, behavior:'smooth'});
    }, 3000);
  }
  function render(cart) {
    const state = getState(cart);
    document.querySelectorAll('[data-pads-offer]').forEach(offer => {
      const items = cart.items || [];
      offer.querySelectorAll('[data-addon-card]').forEach(card => {
        const cardProductId = Number(card.dataset.addonProductId);
        card.hidden = items.some(item => Number(item.product_id) === cardProductId && Number(item.quantity || 0) > 0);
      });
      const visibleCards = [...offer.querySelectorAll('[data-addon-card]')].filter(card => !card.hidden);
      offer.hidden = !state.other || visibleCards.length === 0;
      if (offer.dataset.addonDotEvents !== 'true') {
        const track = offer.querySelector('[data-addon-carousel]');
        track?.addEventListener('scroll', () => window.requestAnimationFrame(() => updateDots(offer)), {passive:true});
        offer.dataset.addonDotEvents = 'true';
      }
      updateDots(offer);
      startAutoPlay(offer);
    });
    document.querySelectorAll('[data-pads-rule]').forEach(node => {node.hidden = !state.invalid; node.textContent = state.invalid ? limitMessage : '';});
    document.querySelectorAll('.cart-drawer__checkout').forEach(button => {
      const blocked = !cart.item_count || state.invalid;
      button.setAttribute('aria-disabled',String(blocked)); button.tabIndex = blocked ? -1 : 0;
    });
    document.querySelectorAll('[data-cart-quantity="1"]').forEach(button => {
      const item = (cart.items || []).find(line => line.key === button.dataset.key);
      if (item && Number(item.product_id) === productId) button.disabled = state.pads >= 1;
    });
  }
  window.TheirSidePads = {render, productId};
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-addon-variant]');
    if (!select) return;
    const price = select.closest('[data-addon-card]')?.querySelector('[data-addon-price]');
    if (price) price.textContent = select.selectedOptions[0]?.dataset.price || '';
  });
  document.addEventListener('click', async event => {
    const dot = event.target.closest('[data-addon-dot]');
    if (dot) {
      const offer = dot.closest('[data-pads-offer]');
      const track = offer?.querySelector('[data-addon-carousel]');
      const cards = [...(offer?.querySelectorAll('[data-addon-card]') || [])].filter(card => !card.hidden);
      const card = cards[Number(dot.dataset.addonDot)];
      if (track && card) {
        const left = track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollTo({left, behavior:'smooth'});
      }
      return;
    }
    const button = event.target.closest('[data-addon-add]');
    if (!button) return;
    event.preventDefault();
    const offer = button.closest('[data-pads-offer]');
    const card = button.closest('[data-addon-card]');
    const status = offer.querySelector('[data-pads-offer-status]');
    const addedProductId = Number(card.dataset.addonProductId);
    button.disabled = true;
    try {
      const cart = await request('cart.js'), state = getState(cart);
      if (addedProductId === productId && (!state.other || state.pads >= 1)) {
        status.textContent = limitMessage;
        return;
      }
      if ((cart.items || []).some(item => Number(item.product_id) === addedProductId && Number(item.quantity || 0) > 0)) {
        status.textContent = 'This product is already in your cart.';
        return;
      }
      const select = card.querySelector('[data-addon-variant]');
      if (!select?.value || select.selectedOptions[0]?.disabled) throw new Error('This pack is currently sold out.');
      await request('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:select.value,quantity:1})});
      if (document.body.dataset.padsCartPage === 'true') {window.location.reload(); return;}
      document.dispatchEvent(new CustomEvent('theirside:pads-added'));
    } catch(error) {status.textContent = error.message;}
    finally {button.disabled = false;}
  });
  document.addEventListener('submit',event => {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    const data = new FormData(form);
    if (!variants.has(String(data.get('id')))) return;
    event.preventDefault(); event.stopImmediatePropagation();
  },true);
  document.addEventListener('submit',event => {
    const form = event.target;
    if (!form.matches('[data-pads-cart-form]') || event.submitter?.name !== 'checkout') return;
    const lines = [...form.querySelectorAll('[data-cart-product]')];
    const pads = lines.filter(input => Number(input.dataset.cartProduct) === productId).reduce((sum,input) => sum + Math.max(0,Number(input.value)||0),0);
    const other = lines.some(input => Number(input.dataset.cartProduct) !== productId && Number(input.value)>0);
    if (pads > 1 || (pads && !other)) {
      event.preventDefault();
      const node = document.querySelector('[data-pads-rule]'); node.hidden = false; node.textContent = limitMessage; node.scrollIntoView({block:'center'});
    }
  },true);
  request('cart.js').then(render).catch(() => {});
})();